import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from '@/contexts/AuthContext';
import {
  checkPlanLimit,
  type PlanLimitCheck,
} from '@/services/organizations.service';

export type { PlanLimitCheck };

/**
 * Hook that provides the current organization context.
 * Used by mutation hooks to include organization_id in INSERTs
 * and by query hooks to scope cache keys.
 *
 * Throws if no organization is set (user hasn't completed onboarding).
 */
export function useOrganization() {
  const { organizationId, orgRole, isOwner } = useAuthContext();

  return {
    organizationId,
    orgRole,
    isOwner,
    /**
     * Returns organizationId or throws.
     * Use in mutations where org_id is required.
     */
    requireOrgId(): string {
      if (!organizationId) {
        throw new Error('Nenhuma organização selecionada. Complete o onboarding primeiro.');
      }
      return organizationId;
    },
  };
}

export function usePlanLimits(tipo: string) {
  const { organizationId } = useOrganization();

  return useQuery({
    queryKey: ['plan-limits', organizationId, tipo],
    queryFn: () => checkPlanLimit({ orgId: organizationId!, tipo }),
    enabled: !!organizationId,
  });
}
